_collow.components.RangeDropdown = class RangeDropdown extends (
  _collow.components.Base
) {
  root;
  elements;
  params;
  value;

  constructor(root, elements, params) {
    super();

    this.root = root;
    this.elements = elements;
    this.params = params;

    this.listen(
      elements.close,
      "click",
      () => (elements.checkbox.checked = false)
    );
    this.listen(elements.range, "change", this.updatePosition);
    this.listen(elements.reset, "click", this.reset);
    this.listen(elements.submit, "click", this.sendValue);
    this.listen(document.body, "_collow.company-search-reset", this.reset);
  }

  updatePosition = ({ target }) => {
    this.value = target.value;
    this.updateNumber();
  };

  updateNumber = () => {
    this.elements.slidingNumber.innerHTML = this.value;
    this.elements.slidingNumber.style.left = `calc(((18rem / 100) * ${this.value}) + 1rem)`;
  };

  reset = () => {
    this.value = "";
    this.elements.range.value = 100;
    this.updateNumber();
    this.sendValue();
  };

  sendValue = () => {
    this.dispatch(this.root, `_collow.range-value-${this.params.for}`, [
      `${this.params.for}Filter`,
      this.value,
    ]);
    this.elements.label.textContent = this.value
      ? `${this.params.short}: ${this.value}`
      : this.elements.label.dataset.default;
    this.elements.checkbox.checked = false;
  };
};
